/**
 * EntryAmountField — сумма ручной операции и её последствие.
 *
 * Поле и строка «остаток станет» неразделимы: ошибку в разряде видно
 * не в сумме, а в том, что получается после. Поэтому они здесь вместе,
 * а не рядом в форме.
 *
 * Когда ввод не разобрался, молчать нельзя. Раньше кнопка просто
 * запиралась, и «1,234,567» выглядело как сломанный экран — человек
 * видел правильную на свой взгляд сумму и запертое сохранение, без
 * единого слова почему.
 */

import {Field, TextInput} from '@components/FormKit';
import {cn} from '@lib/utils';
import {formatTiyin} from '@utils/format';

type Props = {
  value: string;
  onChange: (next: string) => void;
  /** Разобранная сумма; 0 — ввод не распознан или пустой. */
  amountTiyin: number;
  nextBalanceTiyin: number;
};

export const EntryAmountField = ({value, onChange, amountTiyin, nextBalanceTiyin}: Props) => {
  const typed = value.trim() !== '';
  const bad = typed && amountTiyin === 0;

  return (
    <>
      <Field label="Сумма, сом" className="mt-3.5">
        <TextInput
          mono
          inputMode="decimal"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="30 000"
        />
      </Field>

      {typed && (
        <div
          className={cn(
            'mt-2 rounded-[10px] px-[13px] py-2 text-[12.5px] leading-[1.45]',
            bad ? 'bg-destructive/10 text-destructive' : 'bg-skr-head text-skr-ink2',
          )}
        >
          {bad ? (
            'Сумма не распознана: только цифры, не больше двух знаков после запятой, не больше 10 млн сом'
          ) : (
            <>
              Остаток станет{' '}
              <span
                className={cn(
                  'font-mono font-semibold',
                  nextBalanceTiyin < 0 && 'text-destructive',
                )}
              >
                {formatTiyin(nextBalanceTiyin)}
              </span>
            </>
          )}
        </div>
      )}
    </>
  );
};
